import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { HEADLINER_LIST_ID } from "../headliner";
import { HeadlinerMap } from "../components/headliner-map";

const LandingPage = () => (
  <div className="flex flex-col gap-10 pb-24">
    <HeadlinerMap
      source={{ id: HEADLINER_LIST_ID }}
      panel={
        <div className="flex flex-col gap-4">
          <h1 className="font-display text-[clamp(32px,4.5vw,48px)] font-normal leading-[1.02] tracking-[-0.02em]">
            Where we <em className="italic text-brand">gonna eat?</em>
          </h1>
          <p className="max-w-[40ch] text-[14px] text-muted-foreground">
            Every place you've saved, every list you've made, one table you can actually scan.
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <Button asChild variant="brand">
              <Link to="/login">Sign in</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/register">Create an account</Link>
            </Button>
          </div>
        </div>
      }
    />
  </div>
);

export default LandingPage;
